module.exports = __webpack_public_path__ + "static/loving-map-346b82a81755555877e855e0c1c8e663.png";